﻿import { sso } from '../auth/sso';

const fetchSecuredFile = async (filePath) => {
  try {
    const tokenResponse = await fetchToken();

    // check for leading slash and remove
    const formattedPath = filePath.replace(/^\/+/, '');
    const encodedPath = encodeURIComponent(formattedPath);

    const response = await fetch(`/files/${encodedPath}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${tokenResponse.accessToken}`,
      },
    });

    // A 401 here means the session was revoked server-side (not merely "no
    // token") — hand it to sso.onUnauthorized() for the silent-refresh /
    // bounded-streak re-auth policy before surfacing the failure.
    if (response.status === 401) {
      await sso.onUnauthorized();
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    // temp a tag to trigger download
    const a = document.createElement('a');
    a.href = blobUrl;
    // append file name
    a.download = formattedPath.split('/').pop() || 'downloaded-file';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Revoke the object URL after some time to free memory
    setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
  } catch (error) {
    console.error('Failed to open the file:', error);
    throw error;
  }
};

const fetchSignedURL = async (path) => {
  try {
    const tokenResponse = await fetchToken();
    const encodedPath = encodeURIComponent(path);
    const res = await fetch(`/api/securefiles/sign-url?path=${encodedPath}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${tokenResponse.accessToken}`,
      },
    });

    // A 401 here means the session was revoked server-side (not merely "no
    // token") — hand it to sso.onUnauthorized() for the silent-refresh /
    // bounded-streak re-auth policy before surfacing the failure.
    if (res.status === 401) {
      await sso.onUnauthorized();
    }

    if (!res.ok) {
      console.error('Failed to get signed URL', await res.text());
      return;
    }

    const { url } = await res.json();
    window.open(url, '_blank');
  } catch (err) {
    console.error('Error opening preview', err);
  }
};

const fetchToken = async () => {
  const accessToken = await sso.getToken();
  if (!accessToken) {
    throw new Error('No active session! Verify a user has been signed in.');
  }
  return { accessToken };
};

export { fetchSecuredFile, fetchSignedURL };
